/**
 * Module dependencies,
 */

import { Link } from './links/link';
import { textStyles } from 'src/components/core/text';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  items: {
    label?: string;
    url?: string;
  }[];
};

/**
 * `Nav` styled component.
 */

const Nav = styled.div`
  position: relative;
  z-index: 2;
`;

/**
 * `List` styled component.
 */

const List = styled.ul`
  display: flex;
  flex-wrap: wrap;
`;

/**
 * `ListItem` styled component.
 */

const ListItem = styled.li`
  ${textStyles.small}

  display: inline-block;

  &:not(:last-child)::after {
    content: '>';
    margin: 0 6px;
  }

  &:last-child:not(:first-child) {
    opacity: 0.5;
  }
`;

/**
 * `UnstyledLink` styled component.
 */

const UnstyledLink = styled(Link)`
  border: none;
`;

/**
 * Export `Breadcrumbs` component.
 */

export function Breadcrumbs({ items, ...rest }: Props) {
  if (!items.length) {
    return null;
  }

  return (
    <Nav
      aria-label={'Breadcrumb'}
      role={'navigation'}
      {...rest}
    >
      <List>
        {items.map(
          ({ label, url }) =>
            label && (
              <ListItem key={label + url}>
                {!url ? label : <UnstyledLink href={url}>{label}</UnstyledLink>}
              </ListItem>
            )
        )}
      </List>
    </Nav>
  );
}
